import   React          ,
       { useState       ,
         useEffect      ,
         useRef         }  from 'react';

import   classNames        from 'classnames';

import   styles            from './LegalStructureSelector.module.scss';

import { LegalStructure }  from '../../../dataTypes/legalStructureManagment/types';

import { groupData                        ,
         GroupedData                      ,
         initializedGroupedData           ,
         completeGroupData                }  from "../../../dataTypes/dataSetManagment/regroupData";	

import { convertDateToString              ,
         convertStringToDate                   }  from '../../../dataTypes/timeManagment/utils';
		 
import   Select            from '../../widget/inputs/Select';
import   Field             from '../../widget/inputs/Field';
import   Icon              from '../../widget/images/Icon';
import   Trigger           from '../../widget/actuators/Trigger';
import   TabularDisplay    from "../../widget/dataDisplay/tables/TabularDisplay";

//import   LegalStructureSheet        from './LegalStructureSheet';


export interface LegalStructureSelectorProps {
  onCancel?         : () => void | null;
  onSelect?         : (id: number) => void | null;
  legalStructureSet : LegalStructure[];
  componentWidth?   : number;  // Largeur du composant (par défaut 972)
  componentHeight?  : number; // Hauteur du composant (par défaut 626)
  originalFilter?   : string[];
}

export const LegalStructureSelector = ({ onCancel               ,
                                         onSelect               ,
                                         legalStructureSet      ,
                                         componentWidth  = 1210 ,
                                         componentHeight =  626 ,
								         originalFilter  = []   }: LegalStructureSelectorProps) => {

  const sortTypes = [ 'Date de création', 'Ordre alphabétique' ];

  const [ originalLegalStructureSet ] = useState<LegalStructure[]>(legalStructureSet);
  const [       , setFilteredLegalStructureSet ] = useState<LegalStructure[]>(legalStructureSet);
  const [ groupedData                    , setGroupedData               ] = useState<GroupedData<LegalStructure>>(initializedGroupedData<LegalStructure>())
  const [ sortType                ] = useState(sortTypes[0]);
  const [ selectedSortingCriteria        , setSelectedSortingCriteria   ] = useState('Aucun tri');
  const [ filter                         , setFilter                    ] = useState('');
  const [ showCreateWindow               , setShowCreateWindow          ] = useState(false);

  const creationWindowRef = useRef<HTMLDivElement>(null);
    
  useEffect(() => {
    console.log ("LegalStructureSelector =>", legalStructureSet);
	
		  const groupedDataLocal = groupData<LegalStructure> (legalStructureSet, getGroupKey(sortType));

      const completedGroupDataLocal = (() => {
  
        switch (sortType) 
		 {
        /*  case sortTypes[0] : return date1 && date2
                                           ? completeGroupData<LegalStructure>(groupedDataLocal, "1 jour", date1, date2)
                                           : completeGroupData<LegalStructure>(groupedDataLocal, "1 jour");*/
		  case sortTypes[1] : return completeGroupData<LegalStructure>(groupedDataLocal, "", undefined, undefined, "letter");
		  case sortTypes[2] : return completeGroupData<LegalStructure>(groupedDataLocal, "", undefined, undefined, "other");
		  default           : return completeGroupData<LegalStructure>(groupedDataLocal, "1 jour");
         }
        })();

      setGroupedData (completedGroupDataLocal)
  }, [legalStructureSet]);

  useEffect(() => {
    filterLegalStructures();
  }, [selectedSortingCriteria, filter]);

  useEffect(() => {
    if (showCreateWindow && creationWindowRef.current) {
      creationWindowRef.current.scrollTop = 0;
    }
  }, [showCreateWindow]);


  const getGroupKey = (sortType: string) => {

    switch (sortType)
     {
      case sortTypes[0] : return (legalStructure: LegalStructure) => ({
                                                    key      : convertDateToString(legalStructure.creationDate, "yyyy/MM/dd"),
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`
                                                 });

case sortTypes[1]:
  return (legalStructure: LegalStructure) => {
    const match = legalStructure.companyName.match(/[a-zA-Z]/);
    const letter = match ? match[0].toUpperCase() : '#'; // ou autre fallback

    return {
      key: letter,
      renderer: (val: string) => val,
    };
  };


      default           : throw new Error(`Unknown sort type: ${sortType}`);
     }
  };
  
  const filterLegalStructures = () => {

    if (originalLegalStructureSet.length > 0)
     {
      let filteredLegalStructures = originalLegalStructureSet.filter((legalStructure) =>
       {
        const matchesFilter    = legalStructure.companyName.toLowerCase().includes(filter.toLowerCase());

        return matchesFilter;
       }
      );

      if (selectedSortingCriteria === 'Par ordre alphabétique')
            {
             filteredLegalStructures.sort();
            }
			
      setFilteredLegalStructureSet(filteredLegalStructures);
	  
	  const groupedDataLocal = groupData<LegalStructure> (filteredLegalStructures, getGroupKey(sortType));

      const completedGroupDataLocal = (() => {
  
        switch (sortType) 
		 {
        /*  case sortTypes[0] : return date1 && date2
                                           ? completeGroupData<LegalStructure>(groupedDataLocal, "1 jour", date1, date2)
                                           : completeGroupData<LegalStructure>(groupedDataLocal, "1 jour");*/
		  case sortTypes[1] : return completeGroupData<LegalStructure>(groupedDataLocal, "", undefined, undefined, "letter");
		  case sortTypes[2] : return completeGroupData<LegalStructure>(groupedDataLocal, "", undefined, undefined, "other");
		  default           : return completeGroupData<LegalStructure>(groupedDataLocal, "1 jour");
         }
        })();

      setGroupedData (completedGroupDataLocal)
    }
  };


  const handleSortingCriteriaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSortingCriteria(e.target.value);
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };

  const renderSortingCriteria = (): JSX.Element => {
    const sortingCriteriaNames = [
      'Aucun tri',
      'Par ordre alphabétique'
    ];

    return (
      <Select choices  = {sortingCriteriaNames}
              value    = {selectedSortingCriteria}
              onChange = {handleSortingCriteriaChange} />
    );
  };

  const handleCloseButtonClick = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleCreationWindowShow = () => {
    setShowCreateWindow(true);
  };




  const handleRowClick = (element:LegalStructure) => {

    console.log ('handleRowClick:', element)

    if ( onSelect )
     {
      onSelect ( element.id )
     }
  }

  const renderLegalStructureList = () : JSX.Element => {
	  
    const columns = [
       { header : "Id"                 , accessor: "id"            as keyof LegalStructure },
       { header : "Enseigne"           , accessor: "tradeName"     as keyof LegalStructure },
       {  header : "Nom"                , accessor: "companyName"   as keyof LegalStructure },
       { header : "Siren"              , accessor: "siren"         as keyof LegalStructure },
    ];
  	  
	return <TabularDisplay groupedData      = {groupedData}
                           columns          = {columns}
                           hideEmptyGroups  = {true} 
						   showGroupHeaders = {false} 
						   onRowClick       = {handleRowClick}/>
  }

  return (
    <div className = {classNames(styles.root)}
         style     = {{ width: componentWidth, height: componentHeight }} >

      {/*showCreateWindow && (<LegalStructureSheet onClose ={handleCreationWindowCancel} onCreate={handleLegalStructureCreate} />)*/}

      {/* Croix de fermeture en dehors de search_bar */}
      <div className={classNames(styles.close_button)}>
        <Icon name       = "cross"
              onClick    = {handleCloseButtonClick}
              color      = "#000000"
              hoverColor = "#FFFF00" />
      </div>

      {/* Barre de recherche décalée vers le bas */}
      <div className={classNames(styles.upper_bar)}>
        {/*renderLegalStructureTypeSelection()}
        {renderCategoriesSelection()*/}
        {renderSortingCriteria()}
        <Field type        = "text"
               placeholder = "Filtrer par titre"
               value       = {filter}
               onChange    = {handleFilterChange} />
        <div className={classNames(styles.creationButton)}>
          <Trigger name    = "Créer une entreprise"
                   onClick = {handleCreationWindowShow}
                   variant = "tailwind2" />
        </div>
      </div>

      <div className={classNames(styles.legalStructure_grid)}>
        {renderLegalStructureList()}
      </div>
    </div>
  );
};

export default LegalStructureSelector;
